import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { EventGallery } from '../components/EventGallery';
import { OpeningLead } from '../components/OpeningLead';
import { DreamSection } from '../components/DreamSection';
import { MirrorReveal } from '../components/MirrorReveal';
import { OurStory } from '../components/OurStory';
import { BenefitsTable } from '../components/BenefitsTable';
import { Testimonials } from '../components/Testimonials';
import { PackageList } from '../components/PackageList';
import { Guarantee } from '../components/Guarantee';
import { Urgency } from '../components/Urgency';
import { BookingCalendar } from '../components/BookingCalendar';
import { FinalCTA } from '../components/FinalCTA';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-ink font-sans text-cream selection:bg-gold/30 selection:text-white" data-id="element-489" data-mp="3owvq8b8l6w7b">
      <Header data-id="element-490" data-mp="30wjb2l8dcm2r" />
      <main data-id="element-491" data-mp="30x1go8gx8cnc">
        <Hero data-id="element-492" data-mp="30vqegd34jcyc" />
        <EventGallery data-id="element-493" data-mp="30w9m90z28kyn" />
        <OpeningLead data-id="element-494" data-mp="30uoypvb5y2aa" />

        <DreamSection data-id="element-495" data-mp="2vxyceq8rmagf" />

        <MirrorReveal data-id="element-496" data-mp="2vyq7lzyga666" />
        <OurStory data-id="element-497" data-mp="2vy818ai2qbkj" />
        <BenefitsTable data-id="element-498" data-mp="2vvlta9r9tu1s" />
        <Testimonials data-id="element-499" data-mp="2qybwua5gsi4g" />
        <PackageList data-id="element-500" data-mp="2qxu4holxao1t" />
        <Guarantee data-id="element-501" data-mp="2qx0tucjufeee" />
        <Urgency data-id="element-502" data-mp="2r0oppicrgcwa" />
        <BookingCalendar data-id="element-503" data-mp="2mx0i4zo4phb1" />
        <FinalCTA data-id="element-504" data-mp="2mxs0v9wmnkjw" />
        <FAQ data-id="element-505" data-mp="2mw8jffz8j3gj" />
      </main>
      <Footer data-id="element-506" data-mp="2mz34n9q2osb0" />
    </div>;
}